// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DoublePictures_wrapper__s5nBr","leftColumn":"DoublePictures_leftColumn__5kAUF","rightColumn":"DoublePictures_rightColumn__tlpPj","image":"DoublePictures_image__HTHkj"};